import z from 'zod';

export const treatmentSearchSchema = z.object({
  page: z.number().int().optional().default(1),
  title: z
    .string()
    .trim()
    .transform(value => (value === '' ? undefined : value))
    .optional(),
});
